import * as Sberbank from './Sberbank'

export const Providers = {
  Sberbank,
}
